import common from '@/store/common/mutations';
import * as types from './mutation-types';
import { SEARCH_PARAMS, GROUPS, MASTER_INFO } from './state';

const getSearchInit = () => {
	return {
		searchParams: {
			cpnyScn: '',
			cpnyNm: '',
			useYn: 'Y'
		},
		groups: {
			currentPage: 1,
			pageUnit: 30,
			totalSize: 0
		},
		masterInfo: {
			readOnlyAuth: true, //신규 권한
			cpnyScn: '',
			cpnyCd: '',
			cpnyNm: '',
			crgrNm: '',
			userName: '',
			partType: '',
			crgrTn: '',
			eml: '',
			fax: '',
			regn: '',
			adr: '',
			useYn: '',
			sortNo: '',
			ssClass: '',
			ssClassNm: ''
		}
	};
};

export default {
	...common,
	[types.STATE_INIT]: state => {
		state.searchParams = SEARCH_PARAMS();
		state.masterInfo = MASTER_INFO();
		state.groups = GROUPS();
		state.compMst = [];
		state.PartTypeList = [];
		state.gridList = [];
		state.useYnList = [];
		state.ssClassList = [];
	},
	[types.STATE_CLEAR]: state => {
		state.masterInfo = MASTER_INFO();
	},
	[types.SEARCH_PARAM]: (state, payload) => {
		state.searchParams[payload.key] = payload.value;
	},
	[types.DEFAULT_ASSIGN]: (state, { key, value }) => {
		state[key] = value;
	},
	[types.GROUPS]: (state, { key, value }) => {
		state.groups[key] = value;
	},
	[types.COMP_MST_MASTER_INFO]: (state, { key, value }) => {
		state.masterInfo[key] = value;
	},
	[types.SEARCH_INIT]: state => {
		Object.assign(state, getSearchInit());
	}
};
